module.exports = __webpack_public_path__ + "img/seguridad.3ae72c81.png";